import React from 'react';
import { TreeSelect } from 'antd';
import { TreeSelectOption } from 'antd-mobile/es/components/tree-select';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import {
  AIR_HUMIDITY,
  AIR_TEMPERATURE,
  ET0,
  RAIN_RATE,
  SOLAR_RADIATION,
  WIND_SPEED,
  WIND_GUST,
  WIND_DIRECTION,
  GUST_DIRECTION,
  RAIN_DEPTH,
} from '../hooks/graph';

const { SHOW_PARENT } = TreeSelect;

const WeatherPresetChartSelect = ({
  onSelectChange, value
}:{onSelectChange: Function, value: string[]}) => {
  const { t } = useTranslation();

  const treeData = [
    {
      title: t('ETO'),
      value: ET0,
      key: ET0,
    },
    {
      title: t('Air Temperature'),
      value: AIR_TEMPERATURE,
      key: AIR_TEMPERATURE,
    },
    {
      title: t('Air Humidity'),
      value: AIR_HUMIDITY,
      key: AIR_HUMIDITY,
    },
    {
      title: t('Rain Rate'),
      value: RAIN_RATE,
      key: RAIN_RATE,
    },
    {
      title: t('Solar Radiation'),
      value: SOLAR_RADIATION,
      key: SOLAR_RADIATION,
    },
    {
      title: t('Wind Speed'),
      value: WIND_SPEED,
      key: WIND_SPEED,
    },
    {
      title: t('Wind Gust'),
      value: WIND_GUST,
      key: WIND_GUST,
    },
    {
      title: t('Wind Direction'),
      value: WIND_DIRECTION,
      key: WIND_DIRECTION,
    },
    {
      title: t('Gust Direction'),
      value: GUST_DIRECTION,
      key: GUST_DIRECTION,
    },
    {
      title: t('Rain Depth'),
      value: RAIN_DEPTH,
      key: RAIN_DEPTH,
    },
  ];

  const onChange = (newValue: string[]) => {
    onSelectChange(newValue);
  };

  const tProps: TreeSelectOption = {
    treeData,
    value,
    onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: t('Charts'),
    className: 'soil-preset-chart-select',
    dropdownStyle: isMobile?{
      position: 'fixed',
      height: '100%',
      padding: '20px'
    }:{},
    getPopupContainer: () => document.getElementById('weatherPresetChartSelect'),
  };

  return (
    <div id="weatherPresetChartSelect">
      <TreeSelect {...tProps} />
    </div>

  );
};

export default WeatherPresetChartSelect;
